const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CategoryRestrictionQuery: any = {
    SearchCategoryRestriction: Backofficebff + '/v1/category-restriction/search',
    GetCategoryRestrictionChildren: Backofficebff + '/v1/category-restriction/children',
};
